import { ErrorMessage, Input } from '@iwoca/orion';
import { Field } from 'redux-form';

export const FormField = (props) => <Field component={FormInput} {...props} />;

const FormInput = ({ input, placeholder, label, meta: { touched, error } }) => (
    <div className="my-l">
        <Input.Root id={input.name}>
            <Input.Label>{label}</Input.Label>
            <Input.Control {...input} placeholder={placeholder} />
            {touched && error && (
                <Input.Status>
                    <ErrorMessage.Root>
                        <ErrorMessage.Icon />
                        <ErrorMessage.Text data-testid="formErrors">
                            {error}
                        </ErrorMessage.Text>
                    </ErrorMessage.Root>
                </Input.Status>
            )}
        </Input.Root>
    </div>
);
